// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
 * Refresh the collection page with the provided filters.
 *
 * @param {string} url_filters - The URL parameters for the filters.
 */
function refreshCollectionPageWithFilters(url_filters) {
	let currentUrl = "//" + location.host + location.pathname;
	let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);

	// Créer un nouvel élément DIV pour insérer le HTML récupéré
	let newPageEl = document.createElement("DIV");
	newPageEl.innerHTML = newPageString;

	// Mise à jour des articles de la collection avec les nouveaux filtres
	var newSection = newPageEl.querySelector(".lf-grid-card-collection");
	document.querySelector(".lf-grid-card-collection").innerHTML = newSection.innerHTML;

	// Mise à jour des filtres actifs
	var activeFilters = newPageEl.querySelectorAll(".active-filters");
	activeFilters.forEach(function (activeFilter) {
		var newActiveFilters = document.querySelectorAll(".active-filters");
		newActiveFilters.forEach(function (newActiveFilter) {
			newActiveFilter.innerHTML = activeFilter.innerHTML;
		});
	});

	// Mise à jour des autres éléments avec la classe 'lf-reload'
	var reloadElems = newPageEl.querySelectorAll(".lf-reload");
	reloadElems.forEach(function (reloadElem, index) {
		var newElems = document.querySelectorAll(".lf-reload");
		newElems[index].innerHTML = reloadElem.innerHTML;
	});

	// Mise à jour de l'URL dans l'historique sans recharger la page
	window.history.replaceState(null, document.title, currentUrl + "?" + url_filters);
	document.querySelector(".lf-grid-card-collection").classList.remove("lf-loading");

	// Vérifie les changements dans les filtres après le rafraîchissement
	checkForChanges();
}

/*********************************************************************************************
 * Return the Shopify section ID of the collection grid.
 *
 * @returns {string} - The section ID of the grid.
 */
function returnShopifySectionId() {
	const gridElem = document.querySelector(".lf-grid-collection");
	const gridSection = gridElem.closest(".shopify-section");
	return gridSection.id;
}

/*********************************************************************************************
 * Return the Shopify section ID without the 'shopify-section-' prefix.
 *
 * @returns {string} - The shortened section ID.
 */
function returnShopifySectionIdShort() {
	return returnShopifySectionId().replace("shopify-section-", "");
}

/*********************************************************************************************
 * Perform a synchronous GET request.
 *
 * @param {string} theUrl - The URL to request.
 * @returns {string} - The response text from the request.
 */
function httpGet(theUrl) {
	var xmlHttp = new XMLHttpRequest();
	xmlHttp.open("GET", theUrl, false); // Synchronous request
	xmlHttp.send(null);
	return xmlHttp.responseText;
}

/*********************************************************************************************
 * Check for changes in the filter inputs and submit the form if changes are detected.
 *
 */
function checkForChanges() {
	var form = document.getElementById("collectionFacetsForm");
	var inputs = form.querySelectorAll("input");
	const isDesktop = window.innerWidth > 1024;

	// Ajouter un listener sur chaque input pour détecter les changements
	inputs.forEach(function (input) {
		input.addEventListener("change", function () {
			if (isDesktop) {
				fakeSubmitForm();
			} else {
				updateApplyButtonState();
			}
		});
	});
}

/*********************************************************************************************
 * Update the sort_by query parameter and reload the page with the new sorting applied.
 *
 * @param {HTMLSelectElement} select - The select element for sorting.
 */
function sortByChanged(select) {
	const hiddenSelect = document.getElementById("sortByHiddenElem");
	hiddenSelect.value = select.value;
	fakeSubmitForm();
}

/*********************************************************************************************
 * Adds a listener on the change of select for sorting
 *
 */
const sortByElement = document.querySelector(".sort_by");
if (sortByElement) {
	sortByElement.addEventListener("change", function (e) {
		var value = e.target.value;
		Shopify.queryParams.sort_by = value;
		location.search = new URLSearchParams(Shopify.queryParams).toString();
	});
}

/*********************************************************************************************
 * Serialize the form data and refresh the collection page with the filters.
 *
 */
function fakeSubmitForm() {
	let form = document.getElementById("collectionFacetsForm");
	let url_filters = new URLSearchParams(new FormData(form)).toString();
	document.querySelector(".lf-grid-card-collection").classList.add("lf-loading");

	// Rafraîchir la collection avec les filtres
	setTimeout(() => {
		refreshCollectionPageWithFilters(url_filters);
	}, "0");
}

/*********************************************************************************************
 * Mobile filter drawer functions for screens smaller than 900px.
 *
 */
/*********************************************************************************************
 * Open the mobile filters drawer.
 *
 */
function openFiltersMobile() {
	var wrapperMobile = document.querySelector(".lf-grid-second-container-filter");
	if (wrapperMobile) {
		wrapperMobile.classList.add("lf-open");
		document.querySelector("html").classList.add("stop-scrolling"); // Empêche le scroll en arrière-plan
	}
}

/*********************************************************************************************
 * Close the mobile filters drawer.
 *
 */
function closeFiltersMobile() {
	var wrapperMobile = document.querySelector(".lf-grid-second-container-filter");
	if (wrapperMobile) {
		wrapperMobile.classList.remove("lf-open");
		document.querySelector("html").classList.remove("stop-scrolling"); // Réactive le scroll
	}
}

window.openFiltersMobile = openFiltersMobile;
window.closeFiltersMobile = closeFiltersMobile;

if (window.innerWidth < 900) {



	/*********************************************************************************************
	 * Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
	 *
	 */
	function checkDrawer() {
		var currentUrl = document.location.href.indexOf("?open_filters");
		if (currentUrl !== -1) {
			openFiltersMobile();
		}
	}
}

/*********************************************************************************************
 * Toggle the accordion state for filters.
 * Automatically opens the first three by default.
 */
function filtersAccordeons() {
	const filtersHeaders = document.querySelectorAll(".lf-cf-tag-filter-header");

	filtersHeaders.forEach(function (filtersHeader, index) {
		// Activer les trois premiers filtres par défaut
		if (index < 3) {
			filtersHeader.classList.add("active");
		}

		// Ajoute un événement de clic pour ouvrir/fermer les filtres
		filtersHeader.addEventListener("click", function () {
			filtersHeader.classList.toggle("active");
		});
	});
}

/*********************************************************************************************
 * Functions for handling price range sliders.
 *
 */
const minRange = document.getElementById("min-range");
const maxRange = document.getElementById("max-range");
const sliderTrack = document.querySelector(".slider-track");
const minRangeValue = document.getElementById("min-range-value");
const maxRangeValue = document.getElementById("max-range-value");

/*********************************************************************************************
 * Update the visual representation of the price range sliders and track.
 *
 */
function updateRange() {
	const minValue = parseInt(minRange.value, 10);
	const maxValue = parseInt(maxRange.value, 10);

	// Affiche les valeurs min et max sans virgules
	minRangeValue.querySelector(".price-min-value").innerHTML = minValue;
	maxRangeValue.querySelector(".price-max-value").innerHTML = maxValue;

	// Calcul des pourcentages pour le fond de la track
	const minPercent = (minValue / minRange.max) * 100;
	const maxPercent = (maxValue / maxRange.max) * 100;

	// Mise à jour du fond de la track pour refléter la plage de prix sélectionnée
	sliderTrack.style.background = `linear-gradient(to right, #ddd ${minPercent}%, var(--black-900) ${minPercent}%, var(--black-900) ${maxPercent}%, #ddd ${maxPercent}%)`;

	// Ajuste la largeur des valeurs min et max sur le slider
	minRangeValue.style.width = `calc(${minPercent}%)`;
	maxRangeValue.style.width = `calc(${maxPercent}%)`;
}

/*********************************************************************************************
 * Event listeners for price sliders
 *
 */
// minRange.addEventListener("input", function () {
// 	if (parseInt(minRange.value) > parseInt(maxRange.value) - 10) {
// 		minRange.value = maxRange.value - 10;
// 	}
// 	updateRange();
// });

// maxRange.addEventListener("input", function () {
// 	if (parseInt(maxRange.value) < parseInt(minRange.value) + 10) {
// 		maxRange.value = parseInt(minRange.value) + 10;
// 	}
// 	updateRange();
// });

/*********************************************************************************************
 * Loaded Listenner
 *
 */
window.addEventListener("DOMContentLoaded", (event) => {
	checkForChanges();
	filtersAccordeons();
	// updateRange();
});

function clearAllFilters() {
	const form = document.getElementById("collectionFacetsForm");
	if (form) {
		const checkboxes = form.querySelectorAll('input[type="checkbox"]');
		checkboxes.forEach(checkbox => {
			checkbox.checked = false;
		});
		
		fakeSubmitForm();
		
		updateApplyButtonState();
	}
}

function hasFiltersChanged() {
	const form = document.getElementById("collectionFacetsForm");
	if (!form) return false;
	
	const checkedBoxes = form.querySelectorAll('input[type="checkbox"]:checked');
	return checkedBoxes.length > 0;
}

function updateApplyButtonState() {
	const applyBtn = document.getElementById("applyFiltersBtn");
	if (!applyBtn) return;
	
	if (hasFiltersChanged()) {
		applyBtn.classList.remove("disabled");
	} else {
		applyBtn.classList.add("disabled");
	}
}

function applyFiltersAndClose() {
	fakeSubmitForm();
	closeFiltersMobile();
}

window.clearAllFilters = clearAllFilters;
window.applyFiltersAndClose = applyFiltersAndClose;

document.addEventListener("DOMContentLoaded", function() {
	updateApplyButtonState();
});


